import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/internal/operators/finalize';
import { LoadingService } from '../services/loading.service';
import { inject } from '@angular/core';
import { LIB_ENVIRONMENT } from '../../modules/vnext/services/environment.token';

/**
 * HTTP interceptor that shows the global loading indicator while requests are
 * in flight and hides it once they complete. Registered in `main.ts` via
 * `provideHttpClient(withInterceptors([...]))`.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  let activeRequests = 0;
  const loadingService = inject(LoadingService);
  const env = inject(LIB_ENVIRONMENT);

  activeRequests++;
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests === 0) {
        loadingService.hide();
      }
    }),
  );
};
